<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-10">
                    <br>
                    <h1>Municipios</h1>
                </div>
                <div class="col-lg-2">
                    <br>
                    <button class="btn btn-success" (click)="openModal(modalAgregar)">Agregar</button>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-11">
                    <div class="row">
                        <div class="col-lg-4">
                            <span>Seleccione Estado:</span>
                            <select  #estadoSelect class="input90" style="padding: 1%;" (change)='getMunicipios(estadoSelect.value)'>
                                <option value="" selected style="color: black;">Seleccione Estado</option>
                                <option *ngFor="let estado of estados" [value]="estado.id" [attr.selected]="estado.id==estadoid ? true : null">{{estado.nombre}}</option>
                            </select>
                            <br><br><br>
                        </div>
                    </div>
                    
                    
                    <table class="table table-striped">
                        <tr>
                            <td>Municipio</td>
                        </tr>
                        <tr  *ngFor="let municipio of municipios">
                            <td>{{municipio.nombre}}</td>
                        </tr>
                        
                    </table>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
</div>


<ng-template #modalAgregar let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h3>Agregar Municipio</h3>

      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <br>
        <div class="row">
            <div class="col-lg-6">
                <select  #estadoAgregar class="input90" style="padding: 1%;">
                    <option value="">Seleccione Estado</option>
                    <option *ngFor="let estado of estados" [value]="estado.id" [attr.selected]="estado.id==estadoid ? true : null">{{estado.nombre}}</option>
                </select>
                <br><br>
            </div>
        </div>
        
        <input [(ngModel)]="formulario.nombre" class="form-control" placeholder="Nombre Municipio"><br>
        <button type="button" class="btn btn-primary" (click)="agregarMunicipio(estadoAgregar.value)">Agregar</button><br>
    </div>

    <div class="modal-footer">
    </div>
</ng-template>

